import React from 'react';
import { SvgIcon } from './svg-icon';

export const Hamburger = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3 18H15V16H3V18ZM3 6V8H21V6H3ZM3 13H21V11H3V13Z" />
  </SvgIcon>
);
